import { noop } from 'lodash'

// Downloads are not applicable to web platforms
export const DownloadsContent = () => null

DownloadsContent.getNumColumns = noop
